export default "__VITE_ASSET__DT_mxK6u__"